import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("preshh_customer_token"));
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!token) { setCustomer(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/customer/me", { headers: { Authorization: `Bearer ${token}` } });
      setCustomer(data);
    } catch { setToken(null); setCustomer(null); localStorage.removeItem("preshh_customer_token"); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback((tk, cust) => {
    localStorage.setItem("preshh_customer_token", tk);
    setToken(tk);
    setCustomer(cust);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("preshh_customer_token");
    setToken(null); setCustomer(null);
  }, []);

  return (
    <AuthContext.Provider value={{ token, customer, loading, login, logout, refresh, setCustomer }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
